import ApiClient from './apiClient'
import {
  ContactTypeRequest,
  GetContactTypeResponse,
  ContactRequest,
} from '../types/contact'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getContactType = async (params: ContactTypeRequest): Promise<any> => ApiClient.get(
  '/api/v1/renderer/contact',
  (contactType: GetContactTypeResponse) => contactType,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postContact = async (params: ContactRequest): Promise<any> => ApiClient.post(
  '/api/v2/renderer/contact',
  (message: string) => message,
  params,
)
